import React, { Component } from "react";
import Radium from "radium";

import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { informal, sortByDateAsc } from "../utilities/date";
import { sm, md, lg } from "../utilities/styles";
import { contentfulClient } from "../App";
import { splashCropStyles, splashHeaderStyles, headerSubtitleStyles } from "./Trends";

const headerStyles = { ...splashHeaderStyles };

const archivePostStyles = {
  height: "375px",
};

sm(archivePostStyles, { height: "400px" });
md(archivePostStyles, { height: "425px" });
lg(archivePostStyles, { height: "450px" });

headerStyles["display"] = "block";

const mediaWidth = 400;
const mediaHeight = 200;

class Archives extends Component {
  componentWillMount() {
    if (!this.props.archivesLoaded) {
      this.props.fetchArchivesPage();
    }
  }

  render() {
    const { posts, splash, title, subtitle } = this.props;
    return (
      <section style={{ paddingTop: "3em" }}>
        <div>
          <div style={splashCropStyles}>
            <div className="intro__header px3">
              <h1 className="mb0">{title}</h1>
              <h3 style={headerSubtitleStyles}>{subtitle}</h3>
            </div>
            <img src={splash} />
          </div>
        </div>
        <div className="clearfix px2">
          <div className="intro__header-mobile mb4 mt2 px3">
            <h1 className="mb0">{title}</h1>
            <h3 className="thin">{subtitle}</h3>
          </div>
          <h2 className="pl2 center">What's New</h2>
          {posts.sort(sortByDateAsc("datePosted")).map((p) => (
            <div
              className="col xs-col-12 sm-col-6 md-col-6 lg-col-4 pl2 pr2"
              style={archivePostStyles}
            >
              <Link to={`/post/${p.id}`}>
                {p.leadImage && (
                  <img
                    alt={p.title}
                    src={
                      p.leadImage.fields.file.url +
                      "?w=" +
                      mediaWidth +
                      "&h=" +
                      mediaHeight +
                      "&fit=fill"
                    }
                    style={{ maxWidth: "100%" }}
                    className="mw-exempt"
                  />
                )}
                {!p.leadImage && (
                  <div
                    style={{
                      position: "relative",
                      cursor: "pointer",
                      backgroundColor: "#f9f9f9",
                      width: mediaWidth,
                      height: mediaHeight,
                    }}
                  >
                    <div
                      style={{
                        width: "20px",
                        position: "absolute",
                        left: "calc(50% - 10px)",
                        top: "calc(50% - 20px)",
                      }}
                    >
                      <svg viewBox="0 0 30 60" xmlns="http://www.w3.org/2000/svg">
                        <polygon points="0 0, 30 30, 0 60" fill="#CCC" />
                      </svg>
                    </div>
                  </div>
                )}
              </Link>
              <div>
                {p.datePosted ? (
                  <p
                    className="thin mb0 mt0"
                    style={{ fontSize: ".8em", lineHeight: "1.5em" }}
                  >
                    {informal(new Date(p.datePosted))}
                  </p>
                ) : (
                  <span></span>
                )}
                <Link to={`/post/${p.id}`}>{p.title}</Link>
                <p className="mt0" style={{ fontSize: ".9em", lineHeight: "1.65em" }}>
                  {p.subtitle}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  const archivesPage = state.archivesPage;
  return {
    posts: state.posts.filter((p) =>
      p.page ? p.page.toLowerCase() === "co-op news" : false,
    ),
    archivesLoaded: state.loaders.archivesPage,
    splash: archivesPage.splash,
    title: archivesPage.title,
    subtitle: archivesPage.subtitle,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchArchivesPage() {
      contentfulClient.getEntries({ content_type: "archivesPage" }).then((response) => {
        dispatch({ type: "LOAD_ARCHIVES_PAGE", content: response });
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Radium(Archives));



// WEBPACK FOOTER //
// ./src/pages/Archives.js